@let active = activeJob$ | async;
@let ready = readyJob$ | async;

@if (active) {
    <span class="ai-chip ai-chip--running">
        <mat-icon class="ai-chip-icon">autorenew</mat-icon>
        AI Setup running…
    </span>
} @else if (ready) {
    <button class="ai-chip ai-chip--ready" type="button"
            (click)="openReview(ready.taskInfoId)">
        <mat-icon class="ai-chip-icon">task_alt</mat-icon>
        AI Setup ready ({{ ready.pendingReviewCount }} pending) — Review
    </button>
}
